import React from 'react'
import PropTypes from 'prop-types'
import Throttle from '../modules/Throttle'
import IsInViewport from '../modules/IsInViewport'
import { Link } from 'react-router-dom'

class Tags extends React.Component {
  list = React.createRef()

  static propTypes = {
    cloud: PropTypes.bool,
    heading: PropTypes.string,
    tags: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        slug: PropTypes.string,
      })
    ),
  }

  constructor(props) {
    super(props)

    this.state = {
      inView: false,
    }
  }

  componentDidMount() {
    const self = this
    window.addEventListener(
      'scroll',
      Throttle(function() {
        self.showTags()
      }, 50)
    )
    setTimeout(() => {
      self.showTags()
    }, 2000)
  }

  showTags() {
    if (!this.state.inView && IsInViewport(this.list.current, 0)) {
      this.setState({
        inView: true,
      })
    }
  }

  render() {
    return (
      <div className={this.props.cloud ? 'c-tags c-tags--cloud' : 'c-tags'}>
        {this.props.heading && (
          <h2 className="c-tags__heading">{this.props.heading}</h2>
        )}
        {!this.props.heading && <h2 className="visually-hidden">Tags</h2>}
        <ul
          ref={this.list}
          className={
            this.state.inView
              ? 'c-tags__list c-tags__list--in-viewport'
              : 'c-tags__list'
          }
        >
          {this.props.tags.map((tag, index) => {
            return (
              <li className="c-tags__tag" key={index}>
                <Link
                  className="c-tags__link"
                  data-uid="blog-tags-link"
                  to={'/blog/tags/' + tag.slug}
                >
                  #{tag.name}
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

Tags.defaultProps = {
  cloud: false,
}

export default Tags
